import styled from 'styled-components';

export const MessagesPageContainer = styled.div`
    .message-header {
        h3 {
            display: inline-block;
        }

        a {
            float: right;
            margin-top: 40px;
        }
    }

    section.info {
        margin-bottom: 50px;

        p {
            margin: 30px 0;
        }
    }

    .info-field {
        color: ${props => props.theme.accountMessageFieldColor};
        font-weight: ${props => props.theme.boldWeight};
    }

    .content {
        margin-bottom: 40px;
        border-bottom: 1px solid ${props => props.theme.accountMessagesBorderColor};

        h4 {
            font-size: 14px;
            margin: 40px 0;
        }

        p {
            margin-bottom: 40px;
        }
    }

    .answer {
        h4 {
            font-size: 14px;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        margin-top: 40px;

        .message-header {
            h3 {
                display: inline-block;
                margin: 0 0 20px 0;
            }

            a {
                float: none;
                margin-top: 0;
                display: block;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/mymessages/MessagePageStyle.js